import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c6993970"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "padding": "0 10px"
  }
};
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import path from 'path';
import { useStore } from 'vuex';
import { isSameRoute } from '@/store/modules/tagsView';
import ScrollPane from './ScrollPane.vue';
import { useRouter, useRoute } from 'vue-router';
import { ElMessageBox } from 'element-plus';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    const {
      t
    } = useI18n();
    const $router = useRouter();
    const $route = useRoute();
    const $store = useStore();
    const tags = ref([]);
    const scrollPane = ref(null);
    const container = ref(null);
    const permissionCode = ref('');
    const hasTip = ref(false);
    // const isTipErrors = ref(true)
    const visible = ref(false);
    const top = ref(0);
    const left = ref(0);
    const selectedTag = ref({});
    const affixTags = ref([]);
    const dashboardSelected = ref(true);
    const boxList = ['building-manage-new-detail']; // 允许关闭页签时弹出的路由名字，后续有相应的需求可以在这里加
    const visitedViews = computed(() => $store.state.tagsView.visitedViews);
    const routes = computed(() => $store.state.permission.routes);
    watch(() => $route.fullPath, () => {
      hasTip.value = $route.meta?.hasTip;
      permissionCode.value = $route.meta?.functionCode;
      addTags();
      moveToCurrentTag();
    });
    watch(visible, value => {
      if (value) {
        document.body.addEventListener('click', closeMenu);
      } else {
        document.body.removeEventListener('click', closeMenu);
      }
    });
    onMounted(() => {
      hasTip.value = $route.meta?.hasTip;
      permissionCode.value = $route.meta?.functionCode;
      initTags();
      addTags();
    });
    function onError(e) {
      console.log('------', e);
      // isTipErrors.value = false
    }
    function onHasTip(tip) {
      console.log('🚀 ~ file: index.vue:138 ~ onHasTip ~ tip:', tip);
      // nextTick(() => {
      //   hasTip.value = tip
      // })
    }
    function isActive(route) {
      dashboardSelected.value = $route.path !== '/dashboard';
      return isSameRoute(route, $route);
    }
    function isAffix(tag) {
      return tag.meta && tag.meta.affix;
    }
    function filterAffixTags(routes, basePath = '/') {
      let tags = [];
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: {
              ...route.meta
            }
          });
        }
        if (route.children) {
          const childTags = filterAffixTags(route.children, route.path);
          if (childTags.length >= 1) {
            tags = [...tags, ...childTags];
          }
        }
      });
      return tags;
    }
    function initTags() {
      affixTags.value = filterAffixTags(routes.value);
      for (const tag of affixTags.value) {
        // Must have tag name
        if (tag.name) {
          $store.dispatch('tagsView/addVisitedView', tag);
        }
      }
    }
    function addTags() {
      const {
        name
      } = $route;
      if (name) {
        $store.dispatch('tagsView/addView', $route);
      }
    }
    async function moveToCurrentTag() {
      await nextTick();
      for (const tag of tags.value) {
        // if ((tag.to as ITagView).path === $route.path) {
        if (tag.to.path === $route.path) {
          scrollPane.value.moveToTarget(tag);
          // When query is different then update
          if (!isSameRoute(tag.to, $route)) {
            $store.dispatch('tagsView/updateVisitedView', $route);
            $store.dispatch('tagsView/delView', tag.to);
          }
          break;
        }
      }
    }
    async function refreshSelectedTag(view) {
      $store.dispatch('tagsView/delCachedView', view);
      const {
        fullPath
      } = view;
      await nextTick();
      $router.replace({
        path: '/redirect' + fullPath
      });
    }
    function closeSelectedTag(view) {
      const isExist = boxList.filter(e => e === view.name);
      const isEdit = $store.state.tagsView.isEdit;
      if (isEdit && isExist.length > 0) {
        ElMessageBox.confirm(t('pc-layout-0'), t('msg-warning'), {
          confirmButtonText: t('ops-ok'),
          cancelButtonText: t('ops-cancel'),
          type: 'warning'
        }).then(() => {
          $store.dispatch('tagsView/delView', view);
          if (isActive(view)) {
            toLastView($store.state.tagsView.visitedViews, view);
            $store.dispatch('tagsView/getEditStatus', false);
          }
        }).catch(() => {});
      } else {
        $store.dispatch('tagsView/delView', view);
        if (isActive(view)) {
          toLastView($store.state.tagsView.visitedViews, view);
        }
      }
    }
    function closeOthersTags() {
      if (selectedTag.value.fullPath !== $route.path && selectedTag.value.fullPath !== undefined) {
        $router.push(selectedTag.value.fullPath);
      }
      $store.dispatch('tagsView/delOthersViews', selectedTag.value);
      moveToCurrentTag();
    }
    function closeAllTags(view) {
      $store.dispatch('tagsView/delAllViews');
      if (affixTags.value.some(tag => tag.path === $route.path)) {
        return;
      }
      toLastView($store.state.tagsView.visitedViews, view);
    }
    function toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView !== undefined && latestView.fullPath !== undefined) {
        $router.push(latestView.fullPath);
      } else {
        // Default redirect to the home page if there is no tags-view, adjust it if you want
        if (view.name === 'Dashboard') {
          // to reload home page
          $router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          $router.push('/');
        }
      }
    }
    function openMenu(tag, e) {
      const menuMinWidth = 105;
      const offsetLeft = container.value.getBoundingClientRect().left; // container margin left
      const offsetWidth = container.value.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const newLeft = e.clientX + 15; // 15: margin right
      if (newLeft > maxLeft) {
        left.value = maxLeft;
      } else {
        left.value = newLeft;
      }
      top.value = e.clientY;
      visible.value = true;
      selectedTag.value = tag;
    }
    function closeMenu() {
      visible.value = false;
    }
    __expose({
      tags
    });
    return (_ctx, _cache) => {
      const _component_postcard = _resolveComponent("postcard");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_close = _resolveComponent("close");
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", {
        ref_key: "container",
        ref: container,
        id: "tags-view-container",
        class: "tags-view-container"
      }, [_createVNode(ScrollPane, {
        ref_key: "scrollPane",
        ref: scrollPane,
        class: "tags-view-wrapper"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visitedViews.value, (tag, i) => {
          return _openBlock(), _createBlock(_component_router_link, {
            ref_for: true,
            ref: el => {
              if (el) tags.value[i] = el;
            },
            key: tag.path,
            class: _normalizeClass([isActive(tag) ? 'active' : '', "tags-view-item"]),
            to: {
              path: tag.path,
              query: tag.query,
              fullPath: tag.fullPath
            },
            onMouseup: _withModifiers($event => !isAffix(tag) ? closeSelectedTag(tag) : '', ["middle"]),
            onContextmenu: _withModifiers($event => openMenu(tag, $event), ["prevent"])
          }, {
            default: _withCtx(() => [isActive(tag) && !hasTip.value ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0
            }, {
              default: _withCtx(() => [_createVNode(_component_postcard)]),
              _: 1
            })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_1, _toDisplayString(tag.custom?.title || _ctx.$t(tag.meta.title)), 1), !isAffix(tag) ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 1,
              class: "close-icon",
              onClick: _withModifiers($event => closeSelectedTag(tag), ["prevent", "stop"])
            }, {
              default: _withCtx(() => [_createVNode(_component_close)]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["class", "to", "onMouseup", "onContextmenu"]);
        }), 128))]),
        _: 1
      }, 512), _withDirectives(_createElementVNode("ul", {
        style: _normalizeStyle({
          left: left.value + 'px',
          top: top.value + 'px'
        }),
        class: "contextmenu"
      }, [!isAffix(selectedTag.value) ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = $event => closeSelectedTag(selectedTag.value))
      }, _toDisplayString(_ctx.$t('pc-layout-4')), 1)) : _createCommentVNode("", true), _createElementVNode("li", {
        onClick: closeOthersTags
      }, _toDisplayString(_ctx.$t('pc-layout-5')), 1)], 4), [[_vShow, visible.value]])], 512);
    };
  }
});